import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Auth, { AWSCognitoProvider } from '@aws-amplify/auth'
import Helmet from 'react-helmet'

import FieldPassword from './FieldPassword/FieldPassword'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import { Alert, PasswordStrength } from 'loyal-react'

import '@loyal_template/password.css'

class ChangePassword extends Component {
  state = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    oldPasswordIsValid: null,
    newPasswordIsValid: null,
    confirmPasswordIsValid: null,
    isChanged: false,
    error: null,
    rules: [
      {
        name: 'Conter caracteres especiais',
        regex: /[!@#$%^&*(),.?":{}|<>]/
      },
      { name: 'Conter números', regex: /\d/ },
      {
        name: 'Conter letras maiúsculas',
        regex: /[A-Z]+/
      },
      {
        name: 'Conter letras minúsculas',
        regex: /[a-z]+/
      },
      {
        name: 'Conter no mínimo 6 caracteres',
        regex: /^.{6,}$/
      }
    ]
  }

  componentDidMount () {
    const userPoolId = process.env.REACT_APP_USER_POOL_ID
    const region = process.env.REACT_APP_REGION
    const userPoolWebClientId = process.env.REACT_APP_CLIENT_ID

    Auth.configure({ userPoolId, userPoolWebClientId, region })
  }

  testRules (rules, password) {
    return Object.values(rules).map(({ name, regex }) => ({
      name,
      // eslint-disable-next-line no-unneeded-ternary
      isValid: password.match(regex) ? true : false
    }))
  }

  handleSuccess = () => {
    this.setState({
      isChanged: true,
      error: null,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      confirmPasswordIsValid: null,
      newPasswordIsValid: null })
  }

  handleError = (error) => {
    this.setState({ error, isChanged: false })
  }

  validateNewPassword = () => {
    let regras = this.testRules(this.state.rules, this.state.newPassword)

    const rules = regras.filter(ele => ele.isValid === false)

    if (rules && rules.length > 0) {
      if (this.state.newPasswordIsValid !== false) {
        this.setState({ newPasswordIsValid: false })
      }
    } else {
      if (this.state.newPasswordIsValid !== true) {
        this.setState({ newPasswordIsValid: true })
      }
    }
  }

  validateConfirmPassword = () => {
    const confirmPasswordIsValid =
      !!this.state.confirmPassword &&
      this.state.newPassword === this.state.confirmPassword
    this.setState({ confirmPasswordIsValid })
    return confirmPasswordIsValid
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const { id_token: idToken, access_token: accessToken, profile } = this.props
    const { oldPassword, newPassword } = this.state

    Auth.setSession({
      username: profile.username,
      provider: AWSCognitoProvider.NAME,
      tokens: { idToken, accessToken }
    }).then(({ user }) => {
      return Auth.changePassword(user, oldPassword, newPassword)
    })
      .then(this.handleSuccess)
      .catch(this.handleError)
  }

  handleInputValue = ({ target: { name, value } }) =>
    this.setState({ isChanged: false, [name]: value })

  isFormValid = () => {
    const {
      oldPasswordIsValid,
      newPasswordIsValid,
      confirmPasswordIsValid
    } = this.state

    return (
      oldPasswordIsValid === null &&
      newPasswordIsValid &&
      confirmPasswordIsValid
    )
  }

  closeAlert = () => this.setState({ error: null, isChanged: false })

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Minha senha - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid px-0 bg-ui-4'>
          <div className='container py-4'>
            <div className='row'>
              <LoggedSidebar selected='/security-access' count={0} />
              <div className='col-12 col-lg-8 mt-0'>
                <div className='row'>
                  {this.state.error && <Alert
                    isError
                    title='Ops! Não foi possível alterar sua senha.'
                    className='pb-2'
                    onClose={this.closeAlert}
                  />}
                  {this.state.isChanged && <Alert
                    title='Senha alterada com sucesso.'
                    className='pb-2'
                    onClose={this.closeAlert}
                    focusable='true'
                  />}
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
                      <div className='col mr-auto'>
                        <h2 className='txt-title txt-font-body txt-initial color-title mr-auto'>
                          Alterar Senha
                        </h2>
                      </div>
                    </div>
                    <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3'>
                      <FieldPassword
                        {...this.state}
                        handleInputValue={this.handleInputValue}
                        handleSubmit={this.handleSubmit}
                        validateConfirmPassword={this.validateConfirmPassword}
                        validateNewPassword={this.validateNewPassword}
                        validateOldPassword={this.validateOldPassword}
                        isFormValid={this.isFormValid}
                      />
                      <div className='col-12 col-sm-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 px-3 px-sm-1'>
                        <PasswordStrength password={this.state.newPassword} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

ChangePassword.propTypes = {
  location: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  id_token: PropTypes.string.isRequired,
  access_token: PropTypes.string.isRequired
}

const mapStateToProps = ({ oidc: { user } }) => ({ ...user })

export default connect(
  mapStateToProps,
  null
)(props => <ChangePassword {...props} />)



// WEBPACK FOOTER //
// ./src/Participant/ChangePassword/ChangePassword.js